var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRepo3(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 32,
    viewBox: "0 0 37 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.2 18.9269V27.0996C25.2 28.7012 23.9016 29.9996 22.3 29.9996H4.9C3.29837 29.9996 2 28.7012 2 27.0996V15.4996C2 13.898 3.29837 12.5996 4.9 12.5996H7.8",
    stroke: "#AF3208",
    strokeWidth: 2.175,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0004 27.1004C33.4028 27.1004 35.3504 25.1528 35.3504 22.7504C35.3504 20.348 33.4028 18.4004 31.0004 18.4004C28.598 18.4004 26.6504 20.348 26.6504 22.7504C26.6504 25.1528 28.598 27.1004 31.0004 27.1004Z",
    stroke: "#AF3208",
    strokeWidth: 2.9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6 16.95C16.0024 16.95 17.95 15.0024 17.95 12.6C17.95 10.1976 16.0024 8.25 13.6 8.25C11.1976 8.25 9.25 10.1976 9.25 12.6C9.25 15.0024 11.1976 16.95 13.6 16.95Z",
    stroke: "#AF3208",
    strokeWidth: 2.9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3555 14.7892L27.259 20.5602",
    stroke: "#AF3208",
    strokeWidth: 2.9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7738 6.6258C28.3274 6.6258 29.5867 5.36642 29.5867 3.8129C29.5867 2.25938 28.3274 1 26.7738 1C25.2203 1 23.9609 2.25938 23.9609 3.8129C23.9609 5.36642 25.2203 6.6258 26.7738 6.6258Z",
    stroke: "#AF3208",
    strokeWidth: 1.87527,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3449 5.22852L17.9502 8.96029",
    stroke: "#AF3208",
    strokeWidth: 1.87527,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRepo3);
export default __webpack_public_path__ + "static/media/repo3.d450186fde5b571e027556f3d1211014.svg";
export { ForwardRef as ReactComponent };